import { SocialNetworksId } from "@/interfaces";
import { Button } from "@/components/ui";
import { helpGuideCopy, unlinkedDescriptions } from "@/components/SocialNetworkProfiles/components";
import { LifeBuoy, LinkIcon, Loader2 } from "lucide-react";
import React from "react";

interface Props {
  networkId: SocialNetworksId;
  isConnecting: boolean;
  connect: () => void;
  needsHelp: boolean;
  setShowHelp: (v: boolean) => void;
}

export function SocialProfileUnlinkedState({ networkId, isConnecting, connect, needsHelp, setShowHelp }: Props) {
  return (
    <div className="flex flex-col grow justify-center items-center text-center px-4 py-2">
      <p className="text-sm w-4/5 text-slate-500 mb-6 leading-relaxed">{unlinkedDescriptions[networkId]}</p>
      <Button
        disabled={isConnecting}
        className="w-full max-w-[200px] text-primary hover:text-white hover:bg-primary border-primary flex items-center justify-center gap-2 py-5 rounded-xl transition-transform active:scale-95 disabled:opacity-70 disabled:pointer-events-none"
        variant="outline"
        onClick={connect}
      >
        {isConnecting ? (
          <>
            <Loader2 className="animate-spin" size={18} />
            Connecting...
          </>
        ) : (
          <>
            <LinkIcon size={18} />
            Connect Account
          </>
        )}
      </Button>

      {helpGuideCopy[networkId] && needsHelp && (
        <div className="relative mt-6 group">
          <div className="absolute inset-0 rounded-full ring-2 ring-slate-300/60 animate-pulse group-hover:opacity-0 transition-opacity duration-300 pointer-events-none" />

          {/* Main Button */}
          <button
            onClick={() => setShowHelp(true)}
            className="relative flex items-center gap-2 px-4 py-2 bg-slate-50 border border-slate-200 rounded-full text-sm font-medium text-slate-600 hover:text-slate-900 hover:bg-slate-100 hover:border-slate-300 transition-all active:scale-95 shadow-sm"
          >
            <LifeBuoy size={14} className="text-primary" />
            Need help?
          </button>
        </div>
      )}
    </div>
  );
}
